import React from "react";
export const ActionTypes = {
    SET_PRODUCTS : 'SET_PRODUCTS',
    SELECTED_PRODUCTS: 'SELECTED_PRODUCT',
    REMOVE_SELECTED_PRODUCTS: 'REMOVE_SELECTED_PRODUCT',

};

export default ActionTypes;